export default __webpack_public_path__ + "static/montserrat-v15-latin-ext_latin-700-1f256dfe24d3d9eff2cfb7cbd2f379ef.woff2";